import {restoreClient} from "@project/sdk/sales";
import {mutationOptions} from "@tanstack/react-query";

import {clientKeys, clientMutationKeys} from "../../../client-keys";

export function restoreClientMutationOptions() {
  return mutationOptions({
    mutationFn: (id: string) => restoreClient(id),
    mutationKey: clientMutationKeys.restoreClient,
    onSuccess: async (_data, id, _context, {client}) => {
      client.removeQueries({queryKey: clientKeys.detail(id)});
      await client.invalidateQueries({queryKey: clientKeys.lists()});
    },
  });
}
